<script>
    import { onMount, onDestroy } from 'svelte'
    import ModeratorService from '../../helpers/ModeratorService'
    import { moderatorStore } from '../../stores/moderatorStore'
    import KeyService from '../../helpers/KeyService'
    import { keyStore } from '../../stores/keyStore'

    import Chip from '../../components/Chip.svelte'
    import KeyDisplay from '../../components/KeyDisplay.svelte'

    let usernameInput
    let apiKeys = []

    let chatKey = ''
    let hypetrainKey = ''

    onMount(async () => {
        const res = await ModeratorService.get()
        const configs = await KeyService.get()
    })

    const unsubscribeKeys = keyStore.subscribe((keys) => {
        apiKeys = keys
        if (keys.length) {
            keys.forEach((key) => {
                if (key.type === 'chat') {
                    chatKey = key
                    return key
                } else {
                    hypetrainKey = key
                }
            })
        }
    })

    onDestroy(unsubscribeKeys)

    async function submitModerator() {
        const modName = usernameInput.value
        const res = await ModeratorService.create(modName)
        // moderators = [...moderators, usernameInput.value]
        usernameInput.value = ''
    }

    async function removeUser(username) {
        const res = await ModeratorService.remove(username)
    }

    async function generateOrUpdateKeys(method, type) {
        if (method === 'create') {
            await KeyService.create({ type })
            return false
        } else {
            const config = apiKeys.find((item) => {
                return item.type === type
            })
            await KeyService.update(config)
        }
    }
</script>

<div
    class="mx-auto w-3/5 min-h-600 flex justify-center items-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
    <div class="w-full shadow sm:rounded-md sm:overflow-hidden">
        <div class="px-4 py-5 bg-white sm:p-6">
            <div class="grid grid-cols-6 gap-6">
                <div class="col-span-6">
                    <h2 class="text-lg font-semibold mt-2">
                        Moderator whitelist
                    </h2>
                    <p class="text-sm leading-5 text-gray-600 mb-2">
                        Users added here will be able to register and access the
                        app.
                    </p>
                </div>
                <div class="col-span-6">
                    <label
                        for="username"
                        class="block text-sm font-medium leading-5 text-gray-700">
                        Username
                    </label>
                    <div class="mt-1 flex rounded-md shadow-sm">
                        <input
                            type="text"
                            bind:this={usernameInput}
                            id="username"
                            class="form-input flex-1 block w-full rounded-none rounded-r-md transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                            placeholder="twitch_usersename" />
                    </div>
                </div>

                <div class="col-span-6 mb-4">
                    <h5
                        class="mb-1 block text-sm font-medium leading-5 text-gray-700">
                        Whitelisted Users
                    </h5>
                    <div class="chiplist">
                        {#if $moderatorStore.length}
                            {#each $moderatorStore as moderator}
                                <Chip
                                    user={moderator.username}
                                    remove={removeUser} />
                            {/each}
                        {:else}
                            <p
                                class="mt-2 text-sm leading-5 text-pink-400 mb-2">
                                Enter a twitch username to give access to app
                            </p>
                        {/if}
                    </div>
                </div>
            </div>
        </div>
        <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
            <span class="inline-flex rounded-md shadow-sm">
                <button
                    on:click={submitModerator}
                    type="submit"
                    class="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out">
                    Add to Whitelist
                </button>
            </span>
        </div>
    </div>
</div>

<style>
    .card {
        margin-top: 1rem;
        padding: 1rem;
    }
</style>
